/* unplugin-vue-components disabled */import { render } from "./bottomBtn.vue?vue&type=template&id=e083cc44&scoped=true"
import script from "./bottomBtn.vue?vue&type=script&lang=js"
export * from "./bottomBtn.vue?vue&type=script&lang=js"

import "./bottomBtn.vue?vue&type=style&index=0&id=e083cc44&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e083cc44"]])

export default __exports__